<template>
  <div class="product is-gray" data-cy="search-item">
    <div class="image d-flex align-items-center justify-content-center">
      <a :href="getUrl">
        <img
          :src="getImageUrl"
          alt=""
          class="img-fluid"
          onerror="this.src = '/images/comingsoon.png';"
          style="max-height: 220px"
        />
      </a>
      <div
        class="hover-overlay d-flex align-items-center justify-content-center"
      >
        <div class="CTA d-flex align-items-center justify-content-center">
          <!--<a href=""class="add-to-cart"><i class="fa fa-shopping-cart"></i></a>-->
          <a :href="getUrl" class="visit-product active"
            ><i class="icon-search"></i>{{ $t('View') }}</a
          >
          <!--<a href=""data-toggle="modal" data-target="#exampleModal" class="quick-view"><i class="fa fa-arrows-alt"></i></a>-->
        </div>
      </div>
    </div>
    <div class="title">
      <a :href="getUrl">
        <h3 class="h6 text-uppercase no-margin-bottom">{{ item.teamName }}</h3>
        <p>
          <span class="small">{{ item.cityStateCountry }}</span
          ><br />
          {{ item.description }}
        </p>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type SearchResult } from '../common/CatalogItem';

const props = withDefaults(
  defineProps<{
    item?: SearchResult;
  }>(),
  {
    item: () => ({ id: '', hideImage: true, imageUrl: '' }) as SearchResult,
  },
);

const getUrl = computed(() => '/custom/item/' + props.item.id);

const getImageUrl = computed(() =>
  props.item.hideImage ? '/images/comingsoon.png' : props.item.imageUrl,
);
</script>

<style scoped></style>
